import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Loader2, CloudDownload, CheckCircle2, AlertTriangle, Link2 } from "lucide-react";
import { toast } from "sonner";

const TONE = {
  importiert: "border-emerald-200 bg-emerald-50 text-emerald-800",
  laeuft: "border-sky-200 bg-sky-50 text-sky-800",
  wiederholung: "border-amber-200 bg-amber-50 text-amber-800",
  fehler: "border-rose-200 bg-rose-50 text-rose-800",
  nur_link: "border-slate-200 bg-slate-50 text-slate-700",
  wartet: "border-slate-200 bg-slate-50 text-slate-700",
};
const ICON = { importiert: CheckCircle2, laeuft: Loader2, fehler: AlertTriangle, wiederholung: AlertTriangle, nur_link: Link2, wartet: CloudDownload };

// Status + (Re-)Import-Button für die Kundendatei aus der Website-Anfrage.
export const FileImportStatus = ({ state, endpoint, link, canImport = true, onChange }) => {
  const [busy, setBusy] = useState(false);
  const timer = useRef(null);
  useEffect(() => {
    if (state?.status === "laeuft" && onChange) timer.current = setTimeout(onChange, 3000);
    return () => clearTimeout(timer.current);
  }, [state, onChange]);
  if (!state && !link) return null;
  const status = state?.status;
  const Icon = ICON[status] || CloudDownload;
  const start = async () => {
    setBusy(true);
    try {
      await api.post(endpoint);
      toast.success("Datei-Import gestartet.");
      setTimeout(() => onChange?.(), 1500);
    } catch (e) { toast.error(e?.response?.data?.detail || "Import konnte nicht gestartet werden."); }
    finally { setBusy(false); }
  };
  return (
    <div className={`border rounded-md px-3 py-2 text-sm flex items-start gap-2 flex-wrap ${TONE[status] || TONE.wartet}`} data-testid="file-import-status">
      <Icon className={`w-4 h-4 mt-0.5 ${status === "laeuft" ? "animate-spin" : ""}`} />
      <div className="flex-1 min-w-[200px]">
        <div data-testid="file-import-message">{state?.message || "Kundendatei liegt als Link vor – noch nicht importiert."}</div>
        {link && <a href={link} target="_blank" rel="noreferrer" className="text-xs underline break-all" data-testid="file-import-link">{link}</a>}
      </div>
      {canImport && link && status !== "laeuft" && (
        <Button size="sm" variant="outline" onClick={start} disabled={busy} data-testid="file-import-button">
          <CloudDownload className="w-3.5 h-3.5 mr-1" /> {status ? "Erneut importieren" : "Datei importieren"}
        </Button>
      )}
    </div>
  );
};
